import { DEFAULT_WEIGHT } from '../weight-and-balance.consts';

export const CSS = `
  @media print {
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
  section {
    font-family: sans-serif;
    font-size: 14px;
    line-height: 20px;
  }

  h1, h3 {
    margin: 0;
  }

  table, th, td {
    border-collapse: collapse;
  }
  
  table {
    border: 1px solid lightgrey;
    width: 100%;
    font-size: 12px;
    line-height: 20px;
  }
  
  tr {
    border-top: 1px solid lightgrey;
    border-left: 1px solid lightgrey;
    border-right: 1px solid lightgrey;
  }
  
  .bordered {
    border: 1px solid lightgrey;
  }
  
  tr.border-bottom {
    border-bottom: 1px solid lightgrey;
  }
  
  .space-row {
    border-top: 1px solid lightgrey;
    border-left: 1px solid rgba(0,0,0,0);
    border-right: 1px solid rgba(0,0,0,0);
    height: 5px;
  }
  
  th, td {
    padding: 0 6px;
  }
  
  hr {
    margin-top: 5px;
    margin-bottom: 5px;
    border: 0;
    border-top: 1px solid #d9d9d9;
  }
  
  .text-muted {
    color: #999999;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }
  .text-left {
    text-align: left;
  }
  
  .bottom-indent {
    margin-bottom: 24px;
  }
  
  .top-indent {
    margin-top: 12px;
  }
  
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  
  .flex-half {
    flex: 1;
    display: flex;
    width: 0;
  }
  
  .flex-2 {
    flex: 2;
    display: flex;
    width: 0;
  }
  
  .flex-10 {
    flex: 10;
    display: flex;
    width: 0;
  }
  
  .flex-8 {
    flex: 8;
    display: flex;
    width: 0;
  }
  
  .flex-7 {
    flex: 7;
    display: flex;
    width: 0;
  }
  
  .time-block {
    line-height: 19px;
  }
  
  .title {
    font-weight: bold;
  }
  
  .short {
    max-width: 150px;
    line-height: 19px;
  }
  
  .sign-line {
    align-self: center;
    flex-grow: 1;
    width: auto;
    display: inline-flex;
    margin-top: 12px;
    border-bottom: 1px solid black;
  }
  
  .full-sign-line {
    width: auto;
    display: block;
    margin-top: 20px;
    border-bottom: 1px solid black;
  }
  
  .image {
    justify-content: center;
    page-break-before: auto;
    page-break-after: auto;
    page-break-inside: avoid;
  }
  
  .stretch {
    align-items: stretch;
    display: flex;
  }
  
  .inline-item {
    width: 100%;
    padding: 0 0 0 10px;
  }
  
  .sign-half {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  
  .table-block {
    margin-right: 12px;
    flex: 1;
    flex-grow: 2;
  }
  
  tr.row-seat {
    border: 1px solid black;
  }
  
  tr.strong-field {
    border: 1px solid black;
    font-weight: bold;
  }
  
  td.row-seat, td.strong-field {
    background-color: #eaeaea;
  }

  .activity-type-preview {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
  }
  .fuel-data {
    font-size: 13px;
  }

  .pass-table {
    width: 95%;
    margin: 1% 0;
  }
  .pass-table tr, .pass-table td, .pass-table th {
    border: 1px solid lightgrey;
  } 
  .pass-table td {
    padding: 3px;
  }
  
  table.pass-table {
    font-size: 12px;
  }
  .pass-table-pilot {
    font-weight: 600;
  }
  .spacing {
    border-color: white;
    padding: 20px;
  }
  
  .pass-block-wrapper {
    padding-right: 10px;
  }
  
  .pass-block {
    display: flex;
    border: 1px solid black;
    border-radius: 5px;
    flex-direction: column;
  }
  
  .pass-block-row {
    flex: 1;
    display: flex;
    flex-direction: row;
  }
  
  .pass-item {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 3px
  }
  
  .pass-item-data {
    display: flex;
    justify-content: space-between;
    background-color: #57ffff;
    display: flex;
    padding: 2px;
  }
  
  .pass-item-data-name {
    display: inline;
  }
  
  .pass-item-data-weight {
    display: inline;
  }
  .pass-item-name {
    background-color: #feff00;
    padding: 2px;
  }
    
  .pass-block-total {
    display: flex;
    justify-content: center;
  }
  
  .pilot-right {
    order: 1;
  }
  
  performance-factors {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .performance-factors-item {
    display: flex;
    margin: 10px 0;
  }
  .performance-factors-item.no-margin {
    margin: 0;
  }

  /* HOT FRAT questionnaire (org-gated, Jack Harter) — plain print text under
     HIGE/HOGE/INIT. Small + dense to match the client's one-page preview.
     Black on white, keep the block on one page. */
  .frat {
    margin-top: 6px;
    font-size: 7px;
    line-height: 1.15;
    color: #000;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .frat-header {
    text-align: center;
    margin-bottom: 2px;
  }
  .frat-title {
    font-size: 8px;
    font-weight: bold;
  }
  .frat-subtitle {
    font-size: 7.5px;
    font-weight: bold;
  }
  .frat-item {
    margin-bottom: 2px;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .frat-question {
    font-weight: bold;
  }
  .frat-sub {
    padding-left: 10px;
  }
  .frat-initials {
    margin-top: 4px;
    text-align: right;
  }

  .plane {
    margin: 0 5px;
}

.cockpit {
  width: auto;
  height: 35px;
  border-radius: 140px 140px 0 0;
  border-top: 5px solid #d8d8d8;
  border-left: 5px solid #d8d8d8;
  border-right: 5px solid #d8d8d8;
}

.double-sided-sign {
  margin: 20px 10px 0 20px
}

.fuselage {
    border-right: 5px solid #d8d8d8;
    border-left: 5px solid #d8d8d8;
    border-bottom: 5px solid #d8d8d8;
}

.row {
    padding: 2px;
    margin-bottom: 2px;
    
}

.seats {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;
    gap: 2px;
    align-items: stretch;
}

.pilot-seat {
    display: flex;
    flex-direction: column;
    min-height: 31px;
    padding: 5px 2px 0;
    position: relative;
    margin: -20px 0 10px;
    order: 1;
    width: 100%;
    text-align: center;
    font-size: 12px;
    line-height: 1rem;
    background: #ffffff;
    border-radius: 5px;
    border: 2px solid #a3a3a3;
}

.left-padding {
  padding-left: 10px
}


.seat {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 5px 2px 0;
    min-height: 31px;
    position: relative;
    text-align: center;
    font-size: 12px;
    line-height: 1rem;
    background: #ffffff;
    border-radius: 5px;
    border: 1px solid #a3a3a3; 
}

 .seat-number {
     display: block;
     position: absolute;
     top: -6px;
     left: 0;
     right: 0;
     margin: 0 auto;
     background-color: #84aee6;
     color: white;
     border-radius: 10%;
     padding: 1px 2px;
     width: 27px;
 }
 
 .name {
     display: block;
     padding-top: 5px;
 }

 .weight {
    margin: auto 0 0 0;
    text-align: center;
    font-size: 12px;
    color: #666;
  }

  .manifest-comments {
    margin-bottom: 5px;
  }

  /* ── Compact print mode (org-gated: added to the root <section> only when
     showFrat / isFratOrg — currently Jack Harter). Shrinks the WHOLE manifest
     to the client's one-page preview density: base text, W&B table, fuel,
     pass table, signs and the image column. Other orgs never get this class,
     so their manifests are byte-identical. Placed last so these rules win. */
  section.manifest-compact {
    font-size: 10px;
    line-height: 13px;
  }
  .manifest-compact h1 {
    font-size: 20px;
    line-height: 24px;
  }
  .manifest-compact table {
    font-size: 9px;
    line-height: 12px;
  }
  .manifest-compact th, .manifest-compact td {
    padding: 0 4px;
  }
  /* Long row labels (Basic Empty Weight, Front Door (+9.9lb …)) WRAP to a
     second line at 9px — nowrap widened the table into the right column. */
  .manifest-compact .fuel-data {
    font-size: 9px;
  }
  .manifest-compact table.pass-table {
    font-size: 9px;
  }
  .manifest-compact .pass-table td {
    padding: 2px;
  }
  .manifest-compact .time-block,
  .manifest-compact .short {
    line-height: 13px;
  }
  .manifest-compact .short {
    max-width: none;
  }
  .manifest-compact .spacing {
    padding: 6px;
  }
  .manifest-compact .top-indent {
    margin-top: 8px;
  }
  .manifest-compact .bottom-indent {
    margin-bottom: 10px;
  }
  .manifest-compact .sign-line {
    margin-top: 8px;
  }
  .manifest-compact .full-sign-line {
    margin-top: 10px;
  }
  .manifest-compact .image img {
    width: 240px;
  }
  .manifest-compact .pilot-seat,
  .manifest-compact .seat {
    font-size: 10px;
    min-height: 26px;
    line-height: 0.8rem;
  }
  .manifest-compact .weight {
    font-size: 10px;
  }
`;

export const NONE = 'None';
export const NA = '-';

export const DEFAULT_PASSENGER = {
  fullName: 'Empty seat',
  weight: DEFAULT_WEIGHT
};
